__turbopack_context__.v({
  "notifications-button": "notifications-button-module-scss-module__X4JvkG__notifications-button",
  "notifications-button--new": "notifications-button-module-scss-module__X4JvkG__notifications-button--new",
  "notifications-button__icon-wrapper": "notifications-button-module-scss-module__X4JvkG__notifications-button__icon-wrapper",
  "tindilin": "notifications-button-module-scss-module__X4JvkG__tindilin",
});
